(() => {
  "use strict";

  // ==========================================================================
  // Global
  // ==========================================================================

  // 名前空間生成
  window.starterkit = window.starterkit || {};

  // ==========================================================================
  // Media Query
  // ==========================================================================

  // クラス定義
  window.starterkit.MediaQuery = class {
    constructor() {
      // ブレークポイント
      this.breakpoints = [
        { name: "sm", minWidth: "576px" },
        { name: "md", minWidth: "768px" },
        { name: "lg", minWidth: "1024px" },
      ];

      // MediaQueryListオブジェクト
      this.matchMedia = new Map(this.breakpoints.map((element) => [element.name, window.matchMedia(`screen and (min-width: ${element.minWidth})`)]));
    }
  };

  // ==========================================================================
  // Collapse
  // ==========================================================================

  // クラス定義
  window.starterkit.Collapse = class {
    constructor(root, { triggers = "", body = "" } = {}) {
      // 親要素
      this.elems = {
        root,
      };

      // 子要素セレクタ
      this._selectors = {
        triggers,
        body,
      };

      // ステート
      this.state = {
        mediaQuery: {},
        overflowMode: null,
        overflowLineClamp: null,
        visibleMode: null,
        visibleMedia: {},
        isVisibleActive: null,
        isActive: null,
      };

      // インスタンス
      this.instances = {
        mediaQuery: new window.starterkit.MediaQuery(),
      };

      this._init();
    }

    _init() {
      this._getElems();
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this._getMediaQuery();
      this.update();

      // インスタンス代入
      this.elems.root.collapse = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _getElems() {
      // 子要素取得
      this.elems.triggers = this.elems.root.querySelectorAll(this._selectors.triggers);
      this.elems.body = this.elems.root.querySelector(this._selectors.body);
    }

    _setParams() {
      // 初期値設定: overflowモード
      if (this.elems.root.classList.contains("-overflow")) {
        this.state.overflowMode = true;
        this.state.overflowLineClamp = parseInt(this.elems.body.dataset.lineClamp, 10);
      }

      // 初期値設定: 常時展開モード
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        if (this.elems.root.classList.contains(`-visible-${key}`)) {
          this.state.visibleMode = true;
          this.state.visibleMedia[key] = true;
        }
      }

      // 初期値設定: 展開状態
      this.state.isActive = this.elems.root.classList.contains("-active");
    }

    _createCustomEvents() {
      const customEventInit = { detail: { collapse: this } };
      const customEventNames = ["init", "show", "hide", "change", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ボタン
      this.elems.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this._onTriggerClick.bind(this));
      });

      // イベント登録: メディアクエリ
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        matchMedia.addEventListener("change", this._onMediaQueryChange.bind(this));
      }
    }

    _getMediaQuery() {
      let isVisibleMediaMatch = false;

      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        this.state.mediaQuery[key] = matchMedia.matches;

        if (this.state.visibleMedia[key] && this.state.mediaQuery[key]) {
          isVisibleMediaMatch = true;
        }
      }

      this.state.isVisibleActive = this.state.visibleMode && isVisibleMediaMatch;
    }

    _onMediaQueryChange(event) {
      window.requestAnimationFrame(() => {
        this._getMediaQuery();

        this.update();
      });
    }

    _onTriggerClick(event) {
      // 常時展開モード時は無効化
      if (this.state.isVisibleActive) {
        return;
      }

      if (event) {
        event.preventDefault();
      }

      this.toggle();
    }

    show() {
      // 常時展開モード時は無効化
      if (this.state.isVisibleActive) {
        return false;
      }

      // アクティブ状態切り替え
      this.state.isActive = true;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.show);
      this.elems.root.dispatchEvent(this._customEvents.change);
    }

    hide() {
      // 常時展開モード時は無効化
      if (this.state.isVisibleActive) {
        return false;
      }

      // アクティブ状態切り替え
      this.state.isActive = false;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.hide);
      this.elems.root.dispatchEvent(this._customEvents.change);
    }

    toggle() {
      // アクティブ状態に応じてトグル
      if (this.state.isActive) {
        this.hide();
      } else {
        this.show();
      }
    }

    update() {
      // 常時展開モードオンかつ対象メディアクエリ
      if (this.state.isVisibleActive) {
        this.elems.root.classList.add("-active");
        this.elems.body.style.WebkitLineClamp = "";
      }
      // それ以外
      else {
        // 状態反映: overflowモード
        if (this.state.overflowMode) {
          if (this.state.isActive) {
            this.elems.root.classList.add("-active");
            this.elems.body.style.WebkitLineClamp = "";
          } else {
            this.elems.root.classList.remove("-active");
            this.elems.body.style.WebkitLineClamp = this.state.overflowLineClamp;
          }
        }
        // 状態反映: 通常モード
        else {
          if (this.state.isActive) {
            this.elems.root.classList.add("-active");
          } else {
            this.elems.root.classList.remove("-active");
          }
        }
      }

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-collapse").forEach((collapseElem) => {
      const collapse = new window.starterkit.Collapse(collapseElem, {
        triggers: ".js-collapse-trigger",
        body: ".js-collapse-body",
      });
      // console.log(collapse);
    });
  });

  // ==========================================================================
  // Tab
  // ==========================================================================

  // クラス定義
  window.starterkit.Tab = class {
    constructor(root, { buttons = "", panels = "" } = {}) {
      // 親要素
      this.elems = {
        root,
      };

      // 子要素セレクタ
      this._selectors = {
        buttons,
        panels,
      };

      // ステート
      this.state = {
        // overflowMode: null,
        activeTabIndex: null,
        // isTouched: null,
      };

      this._init();
    }

    _init() {
      this._getElems();
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this.update();

      // インスタンス代入
      this.elems.root.tab = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _getElems() {
      // 子要素取得
      this.elems.buttons = this.elems.root.querySelectorAll(this._selectors.buttons);
      this.elems.panels = this.elems.root.querySelectorAll(this._selectors.panels);
    }

    _setParams() {
      // 初期値設定: overflowモード
      // if (this.elems.root.classList.contains("-overflow")) {
      //   this.state.overflowMode = true;
      //   this.state.isTouched = false;
      // }

      // 初期値設定: 展開状態
      this.state.activeTabIndex = null;
      this.elems.buttons.forEach((button, i) => {
        if (button.classList.contains("-active")) {
          this.state.activeTabIndex = i;
        }
      });
    }

    _createCustomEvents() {
      const customEventInit = { detail: { tab: this } };
      const customEventNames = ["init", "change", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: タッチ
      // if (this.state.overflowMode) {
      //   this.elems.root.addEventListener(
      //     "mousedown",
      //     this._onRootTouch.bind(this)
      //   );
      //   this.elems.root.addEventListener(
      //     "touchstart",
      //     this._onRootTouch.bind(this)
      //   );
      // }

      // イベント登録: ボタン
      this.elems.buttons.forEach((button) => {
        button.addEventListener("click", this._onButtonClick.bind(this));
      });
    }

    // _onRootTouch(event) {
    //   // タッチ済みフラグ
    //   this.state.isTouched = true;

    //   this.update();
    // }

    _onButtonClick(event) {
      if (event) {
        event.preventDefault();
      }

      // クリックタブ番号取得
      const tabIndex = Array.prototype.findIndex.call(this.elems.buttons, (button, i) => {
        return button === event.target;
      });

      // 切り替え処理実行
      this.change(tabIndex);
    }

    change(tabIndex) {
      // タブ番号セット
      this.state.activeTabIndex = tabIndex;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.change);
    }

    update() {
      // 状態反映: タッチ
      // if (this.state.overflowMode) {
      //   this.elems.root.classList.toggle("-touched", this.state.isTouched);
      // }

      // 状態反映: ボタン
      this.elems.buttons.forEach((button, i) => {
        button.classList.toggle("-active", i === this.state.activeTabIndex);
      });

      // 状態反映: パネル
      this.elems.panels.forEach((panel, i) => {
        panel.classList.toggle("-active", i === this.state.activeTabIndex);
      });

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-tab").forEach((tabElem) => {
      const tab = new window.starterkit.Tab(tabElem, {
        buttons: ".js-tab-button",
        panels: ".js-tab-panel",
      });
      // console.log(tab);
    });
  });

  // ==========================================================================
  // Overflow
  // ==========================================================================

  // クラス定義
  window.starterkit.Overflow = class {
    constructor(root, {} = {}) {
      // 親要素
      this.elems = {
        root,
      };

      // ステート
      this.state = {
        isTouched: null,
      };

      this._init();
    }

    _init() {
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this.update();

      // インスタンス代入
      this.elems.root.overflow = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _setParams() {
      // 初期値設定: タッチ状態
      this.state.isTouched = false;
    }

    _createCustomEvents() {
      const customEventInit = { detail: { overflow: this } };
      const customEventNames = ["init", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: タッチ
      this.elems.root.addEventListener("mousedown", this._onRootTouch.bind(this));
      this.elems.root.addEventListener("touchstart", this._onRootTouch.bind(this));
    }

    _onRootTouch(event) {
      // タッチ済みフラグ
      this.state.isTouched = true;

      this.update();
    }

    update() {
      // 状態反映: タッチ
      this.elems.root.classList.toggle("-touched", this.state.isTouched);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-overflow").forEach((overflowElem) => {
      const overflow = new window.starterkit.Overflow(overflowElem, {});
      // console.log(overflow);
    });
  });

  // ==========================================================================
  // Cookie
  // ==========================================================================

  window.addEventListener("DOMContentLoaded", (event) => {
    const docCookie = document.cookie;
    const cookieElement = document.getElementById("js-cookie");
    const cookieAccept = document.getElementById("js-cookie-accept");
    const cookieDeny = document.getElementById("js-cookie-deny");
    // const cookieConsentDate = 30; // 確認用保存期間
    const cookieConsentDate = 60 * 60 * 24 * 365; // 保存期間1年（秒数）

    if (cookieElement != null) {
      if (docCookie.split(";").some((item) => item.trim().startsWith("cookie_consent_status="))) {
        cookieElement.remove();
      } else {
        cookieAccept.addEventListener("click", () => {
          cookieElement.remove();
          document.cookie = "cookie_consent_status=true; max-age=" + cookieConsentDate;
          alert("同意後の処理は、各プロジェクト毎の案件に合わせて処理してください。");
        });

        cookieDeny.addEventListener("click", () => {
          cookieElement.remove();
          document.cookie = "cookie_consent_status=false; max-age=" + cookieConsentDate;
          alert("拒否後の処理は、各プロジェクト毎の案件に合わせて処理してください。");
        });
      }
    }

    if (docCookie.split(";").some((item) => item.includes("cookie_consent_status=true"))) {
      console.log("cookie同意してます");
    }

    if (docCookie.split(";").some((item) => item.includes("cookie_consent_status=false"))) {
      console.log("cookie拒否してます");
    }
  });

  // ==========================================================================
  // Header
  // ==========================================================================

  // クラス定義
  window.starterkit.Header = class {
    constructor(root, { button = "", menu = "", menuInner = "" } = {}) {
      // 親要素
      this.elems = {
        html: document.documentElement,
        root,
      };

      // 子要素セレクタ
      this._selectors = {
        button,
        menu,
        menuInner,
      };

      // ステート
      this.state = {
        mediaQuery: {},
        stickyMode: null,
        isWindowScrolled: null,
        isActive: null,
      };
      this._lastState = _.cloneDeep(this.state);

      // インスタンス
      this.instances = {
        mediaQuery: new window.starterkit.MediaQuery(),
      };

      this._init();
    }

    _init() {
      this._getElems();
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this._getWindowScroll();
      this._getMediaQuery();
      this.update();

      // インスタンス代入
      this.elems.root.header = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _getElems() {
      // 子要素取得
      this.elems.button = this.elems.root.querySelector(this._selectors.button);
      this.elems.menu = this.elems.root.querySelector(this._selectors.menu);
      this.elems.menuInner = this.elems.root.querySelector(this._selectors.menuInner);
    }

    _setParams() {
      // 初期値設定: stickyモード
      if (this.elems.root.classList.contains("-sticky-top")) {
        this.state.stickyMode = true;
      }
    }

    _createCustomEvents() {
      const customEventInit = { detail: { header: this } };
      const customEventNames = ["init", "menuShow", "menuHide", "menuChange", "scrollChange", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ウィンドウ
      window.addEventListener("scroll", this._onWindowScroll.bind(this));

      // イベント登録: メディアクエリ
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        matchMedia.addEventListener("change", this._onMediaQueryChange.bind(this));
      }

      // イベント登録: ボタン
      this.elems.button.addEventListener("click", this._onButtonClick.bind(this));

      // イベント登録: メニュー
      this.elems.menu.addEventListener("click", this._onMenuClick.bind(this));
    }

    _getWindowScroll() {
      this.state.isWindowScrolled = window.scrollY > 0;
    }

    _getMediaQuery() {
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        this.state.mediaQuery[key] = matchMedia.matches;
      }
    }

    _onWindowScroll(event) {
      window.requestAnimationFrame(() => {
        this._getWindowScroll();

        this.update();
      });
    }

    _onMediaQueryChange(event) {
      window.requestAnimationFrame(() => {
        this._getMediaQuery();

        this.update();
      });
    }

    _onButtonClick(event) {
      if (event) {
        event.preventDefault();
      }

      this.menuToggle();
    }

    _onMenuClick(event) {
      const targetHref = event.target.href;
      if (!targetHref) {
        return;
      }

      const currentUrl = new URL(window.location.href);
      const targetUrl = new URL(targetHref);

      const isMatchOrigin = targetUrl.origin === currentUrl.origin;
      const isMatchPathname = targetUrl.pathname === currentUrl.pathname;
      const isMatchSearch = targetUrl.search === currentUrl.search;
      const hasHash = !!targetUrl.hash;

      if (isMatchOrigin && isMatchPathname && isMatchSearch && hasHash) {
        this.menuHide();
      }
    }

    menuShow() {
      // アクティブ状態切り替え
      this.state.isActive = true;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.menuShow);
      this.elems.root.dispatchEvent(this._customEvents.menuChange);
    }

    menuHide() {
      // アクティブ状態切り替え
      this.state.isActive = false;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.menuHide);
      this.elems.root.dispatchEvent(this._customEvents.menuChange);
    }

    menuToggle() {
      // アクティブ状態に応じてトグル
      if (this.state.isActive) {
        this.menuHide();
      } else {
        this.menuShow();
      }
    }

    update() {
      // lg以上
      if (this.state.mediaQuery.lg) {
        this.state.isActive = false;
        this.elems.button.classList.remove("-active");

        // スクロールロック
        // if (this.state.stickyMode) {
        bodyScrollLock.enableBodyScroll(this.elems.menuInner);
        // }

        this.elems.menu.classList.remove("-animated", "-active");
        this.elems.menu.style.height = "";

        if (this.state.stickyMode && this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
          if (this._lastState.isWindowScrolled === null) {
            // クラス変更
            this.elems.html.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.toggle("-scrolled", this.state.isWindowScrolled);
          } else {
            // トランジション終了時処理セット
            this.elems.root.addEventListener(
              "transitionend",
              (event) => {
                this.elems.root.classList.remove("-animated");
              },
              { once: true }
            );

            // トランジション準備
            this.elems.root.classList.add("-animated");

            // クラス変更
            this.elems.html.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.toggle("-scrolled", this.state.isWindowScrolled);
          }

          // カスタムイベント発火
          this.elems.root.dispatchEvent(this._customEvents.scrollChange);
        }
      }
      // md以下
      else {
        this.elems.html.classList.remove("-scrolled");
        this.elems.root.classList.remove("-scrolled");

        // 開く
        if (this.state.isActive) {
          this.elems.button.classList.add("-active");

          // スクロールロック
          // if (this.state.stickyMode) {
          bodyScrollLock.disableBodyScroll(this.elems.menuInner);
          // }

          // 変更時のみ
          if (this.state.isActive !== this._lastState.isActive) {
            // トランジション終了時処理セット
            this.elems.menu.addEventListener(
              "transitionend",
              (event) => {
                this.elems.menu.classList.remove("-animated");
                this.elems.menu.style.height = "";
                this.elems.menu.classList.add("-active");

                // カスタムイベント発火
                this.elems.root.dispatchEvent(this._customEvents.update);
              },
              { once: true }
            );

            // メニュー高さ取得
            this.elems.menu.classList.add("-preview");
            const menuHeight = this.elems.menu.offsetHeight;
            this.elems.menu.classList.remove("-preview");

            // トランジション準備
            this.elems.menu.style.height = 0;
            this.elems.menu.classList.add("-animated");

            // レンダリング反映を待って高さをセット
            window.requestAnimationFrame(() => {
              this.elems.menu.style.height = `${menuHeight}px`;
            });
          }
        }
        // 閉じる
        else {
          this.elems.button.classList.remove("-active");

          // スクロールロック
          // if (this.state.stickyMode) {
          bodyScrollLock.enableBodyScroll(this.elems.menuInner);
          // }

          // 変更時のみ
          if (this.state.isActive !== this._lastState.isActive) {
            // トランジション終了時処理セット
            this.elems.menu.addEventListener(
              "transitionend",
              (event) => {
                this.elems.menu.classList.remove("-animated");
                this.elems.menu.style.height = "";

                // カスタムイベント発火
                this.elems.root.dispatchEvent(this._customEvents.update);
              },
              { once: true }
            );

            // メニュー高さ取得
            this.elems.menu.classList.add("-preview");
            const menuHeight = this.elems.menu.offsetHeight;
            this.elems.menu.classList.remove("-preview");

            // トランジション準備
            this.elems.menu.classList.remove("-active");
            this.elems.menu.style.height = `${menuHeight}px`;
            this.elems.menu.classList.add("-animated");

            // レンダリング反映を待って高さをセット
            window.requestAnimationFrame(() => {
              this.elems.menu.style.height = 0;
            });
          }
        }
      }

      // 直近のステートを記憶
      this._lastState = _.cloneDeep(this.state);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  // window.addEventListener("DOMContentLoaded", (event) => {
  //   document.querySelectorAll(".js-header").forEach((headerElem) => {
  //     const header = new window.starterkit.Header(headerElem, {
  //       button: ".js-header-button",
  //       menu: ".js-header-menu",
  //       menuInner: ".js-header-menu-inner",
  //     });
  //     console.log(header);
  //   });
  // });

  // ==========================================================================
  // Scroll To Top Button
  // ==========================================================================

  // クラス定義
  window.starterkit.ScrollToTopButton = class {
    constructor(root) {
      // 親要素
      this.elems = {
        root,
      };

      // ステート
      this.state = {
        staticMode: null,
        isWindowScrolled: null,
      };
      this._lastState = _.cloneDeep(this.state);

      this._init();
    }

    _init() {
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this._getWindowScroll();
      this.update();

      // インスタンス代入
      this.elems.root.scrollToTopButton = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _setParams() {
      // 初期値設定: staticモード
      if (this.elems.root.classList.contains("-static")) {
        this.state.staticMode = true;
      }
    }

    _createCustomEvents() {
      const customEventInit = { detail: { scrollToTopButton: this } };
      const customEventNames = ["init", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ウィンドウ
      window.addEventListener("scroll", this._onWindowScroll.bind(this));
    }

    _getWindowScroll() {
      this.state.isWindowScrolled = window.scrollY > 0;
    }

    _onWindowScroll(event) {
      window.requestAnimationFrame(() => {
        this._getWindowScroll();

        this.update();
      });
    }

    update() {
      if (!this.state.staticMode && this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
        if (this.state.isWindowScrolled) {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.replace("-showing", "-show");
            },
            { once: true }
          );

          this.elems.root.classList.add("-showing");
        } else {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.remove("-hiding");
            },
            { once: true }
          );

          this.elems.root.classList.replace("-show", "-hiding");
        }
      }

      // 直近のステートを記憶
      this._lastState = _.cloneDeep(this.state);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-scrolltotopbutton").forEach((scrollToTopButtonElem) => {
      const scrollToTopButton = new window.starterkit.ScrollToTopButton(scrollToTopButtonElem);
      // console.log(scrollToTopButton);
    });
  });

  // ==========================================================================
  // Floating Banner
  // ==========================================================================

  // クラス定義
  window.starterkit.FloatingBanner = class {
    constructor(root) {
      // 親要素
      this.elems = {
        root,
      };

      // ステート
      this.state = {
        isWindowScrolled: null,
        showScrollPosition: 500,
      };
      this._lastState = _.cloneDeep(this.state);

      this._init();
    }

    _init() {
      this._createCustomEvents();
      this._setEvents();
      this._getWindowScroll();
      this.update();

      // インスタンス代入
      this.elems.root.floatingBanner = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _createCustomEvents() {
      const customEventInit = { detail: { floatingBanner: this } };
      const customEventNames = ["init", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ウィンドウ
      window.addEventListener("scroll", this._onWindowScroll.bind(this));
    }

    _getWindowScroll() {
      this.state.isWindowScrolled = window.scrollY >= this.state.showScrollPosition;
    }

    _onWindowScroll(event) {
      window.requestAnimationFrame(() => {
        this._getWindowScroll();

        this.update();
      });
    }

    update() {
      if (this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
        if (this.state.isWindowScrolled) {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.replace("-showing", "-show");
            },
            { once: true }
          );

          this.elems.root.classList.add("-showing");
        } else {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.remove("-hiding");
            },
            { once: true }
          );

          this.elems.root.classList.replace("-show", "-hiding");
        }
      }

      // 直近のステートを記憶
      this._lastState = _.cloneDeep(this.state);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-floatingbanner").forEach((floatingBannerElem) => {
      const floatingBanner = new window.starterkit.FloatingBanner(floatingBannerElem);
      // console.log(floatingBanner);
    });
  });

  // ==========================================================================
  // Site: Utilities ユーティリティー
  // ==========================================================================

  // setWindowEvents
  // ウィンドウイベント一括指定
  const setWindowEvents = ({ resize, scroll, load } = {}) => {
    window.addEventListener("resize", () => {
      window.requestAnimationFrame(() => {
        if (resize) {
          resize();
        }
        if (scroll) {
          scroll();
        }
      });
    });

    window.addEventListener("scroll", () => {
      window.requestAnimationFrame(() => {
        if (scroll) {
          scroll();
        }
      });
    });

    window.addEventListener("load", () => {
      if (resize) {
        resize();
      }
      if (scroll) {
        scroll();
      }
      if (load) {
        load();
      }
    });

    if (resize) {
      resize();
    }
    if (scroll) {
      scroll();
    }
  };

  // ==========================================================================
  // 検索窓 年自動出力
  // ==========================================================================

  const yearOutput = document.querySelectorAll(".js-year-output");
  const currentYearAndMonth = new Date();
  const currentMonth = currentYearAndMonth.getMonth() + 1; // 月は0から始まるため、+1して調整
  let currentNextYear;
  let currentYearArray = [];

  if (currentMonth >= 6) {
    currentNextYear = currentYearAndMonth.getFullYear() + 1;
  } else {
    currentNextYear = currentYearAndMonth.getFullYear();
  }

  for (let i = currentNextYear; i >= 1976; i--) {
    currentYearArray.push(i);
  }

  yearOutput.forEach(function (element) {
    currentYearArray.forEach(function (item) {
      let option = document.createElement("option");
      option.text = item;
      option.value = item;
      element.querySelector(".js-year-output-select").appendChild(option);

      let list = document.createElement("li");
      list.classList.add("js-search-select", "js-products-search-pc__list-item", "p-products-search-pc__list-item");
      list.dataset.select = item;
      element.querySelector(".js-year-output-list").appendChild(list);
      let p = document.createElement("p");
      p.classList.add("js-products-search-pc__list-text", "p-products-search-pc__list-text");
      p.textContent = item;
      list.appendChild(p);
    });
  });

  // ==========================================================================
  // HOME: メインビジュアルスライダー、今月の主な新製品情報スライダー、製品化決定スライダー、掲載物アーカイブスライダー
  // ==========================================================================

  (() => {
    const swiperTopThumbnail = new Swiper("#js-swiper-top-thumbnail", {
      slidesPerView: 4,
      allowTouchMove: false,
    });

    const swiperTopMainvisual = new Swiper("#js-swiper-top-mainvisual", {
      loop: true,
      roundLengths: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 5,
      },
      speed: 600,
      slidesPerView: 1,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: swiperTopThumbnail,
      },
      breakpoints: {
        1190: {
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: "auto",
        },
      },
      on: {
        afterInit: function (swiper) {
          swiper.autoplay.stop();
          setTimeout(function () {
            swiper.autoplay.start();
          }, 600);
        },
      },
    });

    const swiperNewProductInformation = new Swiper("#js-swiper-new-product-information", {
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        momentumRatio: 0.3,
        momentumVelocityRatio: 0.35,
      },
      pagination: {
        el: ".swiper-new-product-information-pagination",
      },
      navigation: {
        nextEl: ".swiper-new-product-information-button-next",
        prevEl: ".swiper-new-product-information-button-prev",
      },
      scrollbar: {
        el: ".swiper-new-product-information-scrollbar",
        hide: false,
        draggable: true,
        dragSize: 63,
      },
    });

    const swiperProductizationDecision = new Swiper("#js-swiper-productization-decision", {
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        momentumRatio: 0.3,
        momentumVelocityRatio: 0.35,
      },
      pagination: {
        el: ".swiper-productization-decision-pagination",
      },
      navigation: {
        nextEl: ".swiper-productization-decision-button-next",
        prevEl: ".swiper-productization-decision-button-prev",
      },
      scrollbar: {
        el: ".swiper-productization-decision-scrollbar",
        hide: false,
        draggable: true,
        dragSize: 63,
      },
    });

    const swiperArchive = new Swiper("#js-swiper-archive", {
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        momentumRatio: 0.3,
        momentumVelocityRatio: 0.35,
      },
    });
  })();

  // ==========================================================================
  // 製品詳細: 関連製品スライダー
  // ==========================================================================

  // 削除
  // (() => {
  //   const swiperProductsDetails = new Swiper("#js-swiper-products-details", {
  //     slidesPerView: "auto",
  //     freeMode: {
  //       enabled: true,
  //       momentumRatio: 0.3,
  //       momentumVelocityRatio: 0.35,
  //     },
  //     pagination: {
  //       el: ".swiper-pagination",
  //     },
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     scrollbar: {
  //       el: ".swiper-scrollbar",
  //       hide: false,
  //       draggable: true,
  //     },
  //   });
  // })();

  // 追加
  (() => {
    const swiperProductsDetails01 = new Swiper("#js-swiper-products-details01", {
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        momentumRatio: 0.3,
        momentumVelocityRatio: 0.35,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    });
  })();

  // ==========================================================================
  // 共通: スクロールバーの幅取得設定
  // ==========================================================================

  let scrollbarWidth;

  (() => {
    scrollbarWidth = window.innerWidth - document.body.clientWidth;

    const onResize = () => {
      scrollbarWidth = window.innerWidth - document.body.clientWidth;
    };

    setWindowEvents({
      resize: onResize,
      scroll: null,
      load: null,
    });
  })();

  // ==========================================================================
  // 共通: モーダルウィンドウ
  // ==========================================================================

  const disableBodyScroll = bodyScrollLock.disableBodyScroll;
  const enableBodyScroll = bodyScrollLock.enableBodyScroll;

  $(function () {
    $(".js-popup-modal").magnificPopup({
      type: "inline",
      preloader: false,
      mainClass: "p-products-popup",
      removalDelay: 200,
      callbacks: {
        open: function () {
          $(".mfp-container").css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
          $(".renew-p-site-header-pc-main").css({ "padding-right": scrollbarWidth + "px" });
          const target = document.querySelector(".mfp-wrap");
          disableBodyScroll(target);
        },
        close: function () {
          $(".renew-p-site-header-pc-main").css({ "padding-right": "" });
          const target = document.querySelector(".mfp-wrap");
          enableBodyScroll(target);
        },
      },
    });
  });

  // ==========================================================================
  // 製品詳細: モーダルウィンドウ
  // ==========================================================================

  $(function () {
    $(".p-products-details-image").magnificPopup({
      delegate: "a",
      type: "image",
      removalDelay: 200,
      gallery: {
        enabled: true,
        preload: [0, 1],
        tCounter: '<span class="mfp-counter">%curr%/%total%</span>',
      },
      image: {
        cursor: "p-products-details-popup",
      },
      callbacks: {
        open: function () {
          $(".mfp-container").css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
          $(".renew-p-site-header-pc-main").css({ "padding-right": scrollbarWidth + "px" });
          const target = document.querySelector(".mfp-wrap");
          disableBodyScroll(target);
        },
        close: function () {
          $(".renew-p-site-header-pc-main").css({ "padding-right": "" });
          const target = document.querySelector(".mfp-wrap");
          enableBodyScroll(target);
        },
      },
    });
  });

  // ==========================================================================
  // TOMIX入門: モーダルウィンドウ
  // ==========================================================================

  $(function () {
    $(".p-introduction-box__details").magnificPopup({
      delegate: "a",
      type: "image",
      removalDelay: 200,
      gallery: {
        enabled: true,
        preload: [0, 1],
        tCounter: '<span class="mfp-counter">%curr%/%total%</span>',
      },
      image: {
        cursor: "p-products-details-popup",
      },
      callbacks: {
        open: function () {
          $(".mfp-container").css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
          $(".renew-p-site-header-pc-main").css({ "padding-right": scrollbarWidth + "px" });
          const target = document.querySelector(".mfp-wrap");
          disableBodyScroll(target);
        },
        close: function () {
          $(".renew-p-site-header-pc-main").css({ "padding-right": "" });
          const target = document.querySelector(".mfp-wrap");
          enableBodyScroll(target);
        },
      },
    });
  });

  // ==========================================================================
  // 製品情報: 左ナビ
  // ==========================================================================

  // 削除
  // (() => {
  //   const duration = 500;
  //   const easing = "easeOutQuart";
  //   const $accordionLevel1 = $('.p-products-table-categories-accordion__level-1-accordion[href="#"]');

  //   $accordionLevel1.on("click", function (event) {
  //     event.preventDefault();
  //     const $accordionLevel1Target = $(this);
  //     const $accordionLevel2 = $accordionLevel1Target.siblings(".p-products-table-categories-accordion__level-2");

  //     if ($accordionLevel1Target.is(".-active")) {
  //       $accordionLevel1Target.removeClass("-active");
  //       $accordionLevel2.slideUp(duration, easing);
  //     } else {
  //       $accordionLevel1Target.addClass("-active");
  //       $accordionLevel2.slideDown(duration, easing);
  //     }
  //   });
  // })();

  // ==========================================================================
  // 製品情報PC: ページネーション
  // ==========================================================================

  (() => {
    const duration = 100;
    const easing = "easeOutQuart";

    $(".p-products-table-pagination-pc__inner").on("click", function () {
      const $pagination = $(this);
      const $paginationList = $pagination.children(".p-products-table-pagination-pc__list");

      if ($pagination.is(".-active")) {
        $pagination.removeClass("-active");
        $paginationList.slideUp(duration, easing);
      } else {
        $pagination.addClass("-active");
        $paginationList.slideDown(duration, easing);
      }
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".p-products-table-pagination-pc__inner").length) {
        if ($(".p-products-table-pagination-pc__inner").is(".-active")) {
          $(".p-products-table-pagination-pc__inner").removeClass("-active");
          $(".p-products-table-pagination-pc__list").slideUp(duration, easing);
        }
      }

      // マージン付与
      const $paginationList = $(".p-products-table-pagination-pc__list").clone(true).insertAfter(".p-products-table-pagination__inner").addClass("cloned").css({ visibility: "hidden", height: "auto", display: "inline-block" });
      $paginationList.find(".p-products-table-pagination-pc__list-text").each(function (index) {
        const $paginationMarginLeft = 124 - $(this).innerWidth();

        $paginationList
          .prev()
          .find(".p-products-table-pagination-pc__list-text")
          .eq(index)
          .css({ "margin-left": $paginationMarginLeft + "px" });
      });
      $(".cloned").remove();
    });

    $(".p-products-table-pagination-pc__list-item").on("click", function () {
      const index = $(this).index() + 1;
      const numCurrent = $(".p-products-table-pagination-pc__current");
      numCurrent.html(index);
      if (!$(this).has(".-current").length) {
        $(this).parent(".p-products-table-pagination-pc__list").find(".-current").removeClass("-current");
      }
      $(this).children(".p-products-table-pagination-pc__list-link").addClass("-current");
    });

    $(".p-products-table-pagination-sp__select").on("change", function (event) {
      event.preventDefault();
      const index = $(this).prop("selectedIndex") + 1;
      const numCurrent = $(".p-products-table-pagination-sp__current");
      numCurrent.html(index);
      const href = "#result";
      location.href = href;
    });
  })();

  // ==========================================================================
  // 製品検索PC: 条件から探す
  // ==========================================================================

  (() => {
    const duration = 100;
    const easing = "easeOutQuart";

    $(".p-products-search-pc__inner").on("click", function () {
      const $searchPC = $(this);
      const $searchPCList = $searchPC.children(".p-products-search-pc__list");
      $(".p-products-search-pc__inner").not($(this)).removeClass("-active");
      $(".p-products-search-pc__inner").not($(this)).children(".p-products-search-pc__list").slideUp(duration, easing);

      if ($searchPC.is(".-active")) {
        $searchPC.removeClass("-active");
        $searchPCList.slideUp(duration, easing);
      } else {
        $searchPC.addClass("-active");
        $searchPCList.slideDown(duration, easing);
      }
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".p-products-search-pc__inner").length) {
        if ($(".p-products-search-pc__inner").is(".-active")) {
          $(".p-products-search-pc__inner").removeClass("-active");
          $(".p-products-search-pc__list").slideUp(duration, easing);
        }
      }
    });

    // 削除
    // $(".p-products-search-pc__list-item").on("click", function () {
    //   if ($(this).has(".p-products-search-pc__list-category").length) {
    //     return false;
    //   } else {
    //     const html = $(this).children(".p-products-search-pc__list-text").html();
    //     const $text = $(this).parent(".p-products-search-pc__list").prev(".p-products-search-pc__text");
    //     // $text.html(html);
    //     if (!$(this).has(".-current").length) {
    //       $(this).parent(".p-products-search-pc__list").find(".-current").removeClass("-current");
    //     }
    //     $(this).children(".p-products-search-pc__list-text").addClass("-current");
    //   }
    // });

    $(".js-products-search-pc__list-item").on("click", function () {
      if ($(this).has(".js-products-search-pc__list-category").length) {
        return false;
      } else {
        const html = $(this).children(".js-products-search-pc__list-text").html();
        const $text = $(this).parent(".js-products-search-pc__list").prev(".js-products-search-pc__text");
        $text.html(html);
        if (!$(this).has(".-current").length) {
          $(this).parent(".js-products-search-pc__list").find(".-current").removeClass("-current");
        }
        $(this).children(".js-products-search-pc__list-text").addClass("-current");
      }
    });

    // select の　option に val追加
    $(".js-search-select").click(function () {
      let $selectOption = $(this).data("select");
      $(this).parents(".js-search-select-target-parents").find(".js-search-select-target").val($selectOption);
    });
  })();

  // ==========================================================================
  // 製品情報: カテゴリ・条件から探す
  // ==========================================================================

  (() => {
    const duration = 500;
    const easing = "easeOutQuart";
    const $paneButton = $(".p-products-table-pane-button");
    const $paneContents = $(".p-products-table-pane-contents");

    $paneButton.not(".-schedule").on("click", function (event) {
      event.preventDefault();

      if ($paneButton.is(".-active")) {
        $paneButton.removeClass("-active");
        $paneContents.slideUp(duration, easing);
      } else {
        $paneButton.addClass("-active");
        $paneContents.slideDown(duration, easing);
      }
    });
  })();

  // ==========================================================================
  // 発売スケジュール: 条件から探す
  // ==========================================================================

  (() => {
    const duration = 500;
    const easing = "easeOutQuart";
    const $paneButton = $(".p-products-table-pane-button");
    const $paneContents = $(".p-schedule-search");

    $(".p-products-table-pane-button" + ".-schedule").on("click", function (event) {
      event.preventDefault();

      if ($paneButton.is(".-active")) {
        $paneButton.removeClass("-active");
        $paneContents.slideUp(duration, easing);
      } else {
        $paneButton.addClass("-active");
        $paneContents.slideDown(duration, easing);
      }
    });
  })();

  // ==========================================================================
  // 製品情報: 発売月が新しい順
  // ==========================================================================

  (() => {
    const duration = 100;
    const easing = "easeOutQuart";

    $(".p-products-table-header-pc__sub-select-text").on("click", function (event) {
      event.preventDefault();
      const $selectText = $(this);
      const $selectTextList = $selectText.siblings(".p-products-table-header-pc__sub-select-list");

      if ($selectText.is(".-active")) {
        $selectText.removeClass("-active");
        $selectTextList.slideUp(duration, easing);
      } else {
        $selectText.addClass("-active");
        $selectTextList.slideDown(duration, easing);
      }
    });

    $(".p-products-table-header-pc__sub-select-list-item").on("click", function (event) {
      event.preventDefault();
      const html = $(this).children(".p-products-table-header-pc__sub-select-list-text").html();
      const $text = $(this).parent(".p-products-table-header-pc__sub-select-list").prev(".p-products-table-header-pc__sub-select-text");
      $text.html(html);

      if (!$(this).has(".-current").length) {
        $(this).parent(".p-products-table-header-pc__sub-select-list").find(".-current").removeClass("-current");
      }
      $(this).addClass("-current");
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".p-products-table-header-pc__sub-select-text").length) {
        if ($(".p-products-table-header-pc__sub-select-text").is(".-active")) {
          $(".p-products-table-header-pc__sub-select-text").removeClass("-active");
          $(".p-products-table-header-pc__sub-select-list").slideUp(duration, easing);
        }
      }
    });
  })();

  // ==========================================================================
  // 製品詳細: ツールチップ
  // ==========================================================================

  (() => {
    tippy(".p-products-details-icon__list-item", {
      placement: "top",
      duration: 300,
    });
  })();

  // ==========================================================================
  // 製品情報: 追従スクロール
  // ==========================================================================

  // 削除
  // (() => {
  //   if ($(".p-products-table-list-sp__tops").length) {
  //     $(window).on("scroll", function () {
  //       const headerHight = 61;
  //       const $listTops = $(".p-products-table-list-sp__tops");
  //       const $list = $(".p-products-table-list-sp");
  //       const $listLast = $(".p-products-table-list-sp__bottoms:last-child");
  //       const listTopsTop = $list.offset().top - headerHight;
  //       const listBottom = $listLast.offset().top - headerHight - $listTops.height();
  //       let listBottomHeight = $list.height() - $listLast.height();

  //       if (listBottomHeight < 0) {
  //         listBottomHeight = 0;
  //       }

  //       if ($(window).scrollTop() > listTopsTop) {
  //         $listTops.css({ position: "fixed", top: headerHight + "px" });
  //         if ($(window).scrollTop() > listBottom) {
  //           $listTops.css({ position: "absolute", top: listBottomHeight + "px" });
  //         }
  //       } else {
  //         $listTops.css({ position: "absolute", top: "0" });
  //       }
  //     });
  //   }
  // })();

  // ==========================================================================
  // 製品情報: 表示切り替え
  // ==========================================================================

  // (() => {
  //   $(".p-products-table-header-pc__main-tools-item" + ".-thumbnail").on("click", function (event) {
  //     event.preventDefault();
  //     $("#js-table-pc .p-products-table-thumbnail").fadeIn(300);
  //     $(".p-products-table-list-pc").fadeOut(0);
  //     $(".p-products-table-thumbnail-card__title").matchHeight();
  //   });

  //   $(".p-products-table-header-pc__main-tools-item" + ".-list").on("click", function (event) {
  //     event.preventDefault();
  //     $(".p-products-table-list-pc").fadeIn(300);
  //     $("#js-table-pc .p-products-table-thumbnail").fadeOut(0);
  //   });

  //   $(".p-products-table-header-sp__main-switch" + ".-thumbnail").on("click", function (event) {
  //     event.preventDefault();
  //     $("#js-table-sp .p-products-table-thumbnail").fadeIn(300);
  //     $("#js-table-list-sp").fadeOut(0);
  //     $(".p-products-table-thumbnail-card__title").matchHeight();
  //   });

  //   $(".p-products-table-header-sp__main-switch" + ".-list").on("click", function (event) {
  //     event.preventDefault();
  //     $("#js-table-list-sp").fadeIn(300);
  //     $("#js-table-sp .p-products-table-thumbnail").fadeOut(0);
  //   });
  // })();

  // ==========================================================================
  // 共通: ヘッダーSP
  // ==========================================================================

  (() => {
    const easing = "easeOutCubic";
    const easing2 = "easeInOutQuad";
    const easing3 = "easeOutQuart";
    const $sp = $(".renew-p-site-header-sp");
    const $spOverlay = $(".renew-p-site-header-sp-overlay");
    const $spBg = $(".renew-p-site-header-sp-bg");
    const $spSearch = $(".renew-p-site-header-sp-search");
    const $spSearchButton = $(".renew-p-site-header-sp-main__search");
    const $spMenu = $(".renew-p-site-header-sp-menu");
    const $spButton = $(".renew-p-site-header-sp-main__button");
    const $spSearchBox = $(".renew-p-site-header-sp-search__box-text");
    const sp = document.querySelector(".renew-p-site-header-sp");

    $('.renew-p-site-header-sp-main__search[href="#"]').on("click", function (event) {
      event.preventDefault();
      const $spSearchHeight = $spSearch.innerHeight();

      if ($spSearchButton.is(".-active")) {
        $spSearchButton.removeClass("-active");
        $sp.removeClass("-active");
        $spOverlay
          .stop(true, true)
          .animate({ opacity: 0 }, 200, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
        $spSearch
          .stop(true, true)
          .animate({ opacity: 0 }, 0, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        enableBodyScroll(sp);
      } else {
        $spSearchButton.addClass("-active");
        $spButton.removeClass("-active");
        $sp.addClass("-active");
        $spOverlay.stop(true, true).css({ display: "block" }).delay(100).animate({ opacity: 1 }, 200, easing2);
        $spBg.stop(true, true).animate({ height: $spSearchHeight }, 300, easing);
        $spSearch.stop(true, true).delay(100).css({ display: "block" }).delay(100).animate({ opacity: 1 }, 200, easing2);
        $spMenu
          .stop(true, true)
          .animate({ opacity: 0 }, 0, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        disableBodyScroll(sp);
        $spSearchBox.focus();
      }
    });

    $('.renew-p-site-header-sp-main__button[href="#"]').on("click", function (event) {
      event.preventDefault();
      const $spMenuHeight = $spMenu.innerHeight();

      if ($spButton.is(".-active")) {
        $spButton.removeClass("-active");
        $sp.removeClass("-active");
        $spOverlay
          .stop(true, true)
          .animate({ opacity: 0 }, 200, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
        $spMenu
          .stop(true, true)
          .animate({ opacity: 0 }, 0, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        enableBodyScroll(sp);
      } else {
        $spButton.addClass("-active");
        $spSearchButton.removeClass("-active");
        $sp.addClass("-active");
        $spOverlay.stop(true, true).css({ display: "block" }).delay(100).animate({ opacity: 1 }, 200, easing2);
        $spBg.stop(true, true).animate({ height: $spMenuHeight }, 300, easing);
        $spMenu.stop(true, true).delay(100).css({ display: "block" }).delay(100).animate({ opacity: 1 }, 200, easing2);
        $spSearch
          .stop(true, true)
          .animate({ opacity: 0 }, 0, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        disableBodyScroll(sp);
      }
    });

    $('.renew-p-site-header-sp-menu-accordion__level-1-accordion[href="#"]').on("click", function (event) {
      event.preventDefault();
      const $accordionLevel1 = $(this);
      const $accordionLevel2 = $accordionLevel1.siblings(".renew-p-site-header-sp-menu-accordion__level-2");

      if ($accordionLevel1.is(".-active")) {
        $accordionLevel1.removeClass("-active");
        let $spMenuHeight = $spMenu.innerHeight();
        const $accordionLevel2CloneHeight = $accordionLevel2.clone(true).insertAfter(this).addClass("cloned").css({ visibility: "hidden", height: "auto", display: "block" }).innerHeight();
        $(".cloned").remove();
        $spMenuHeight = $spMenuHeight - $accordionLevel2CloneHeight;
        $accordionLevel2.stop(true, true).slideUp(500, easing3);
        $spBg.stop(true, true).animate({ height: $spMenuHeight }, 500, easing3);
      } else {
        $accordionLevel1.addClass("-active");
        let $spMenuHeight = $spMenu.innerHeight();
        const $accordionLevel2CloneHeight = $accordionLevel2.clone(true).insertAfter(this).addClass("cloned").css({ visibility: "hidden", height: "auto", display: "block" }).innerHeight();
        $(".cloned").remove();
        $spMenuHeight = $spMenuHeight + $accordionLevel2CloneHeight;
        $accordionLevel2.stop(true, true).slideDown(500, easing3);
        $spBg.stop(true, true).animate({ height: $spMenuHeight }, 500, easing3);
      }
    });

    $('.renew-p-site-header-sp-search__close[href="#"]').on("click", function (event) {
      event.preventDefault();
      $spSearchButton.removeClass("-active");
      $sp.removeClass("-active");
      $spOverlay
        .stop(true, true)
        .animate({ opacity: 0 }, 200, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
      $spSearch
        .stop(true, true)
        .animate({ opacity: 0 }, 0, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      enableBodyScroll(sp);
    });

    $(".renew-p-site-header-sp-search__icon").on("click", function () {
      $spSearchButton.removeClass("-active");
      $sp.removeClass("-active");
      $spOverlay
        .stop(true, true)
        .animate({ opacity: 0 }, 200, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
      $spSearch
        .stop(true, true)
        .animate({ opacity: 0 }, 0, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      enableBodyScroll(sp);
    });

    $(".renew-p-site-header-sp-search__box-text").on("keydown", function (event) {
      if (event.which === 13) {
        $spSearchButton.removeClass("-active");
        $sp.removeClass("-active");
        $spOverlay
          .stop(true, true)
          .animate({ opacity: 0 }, 200, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
        $spSearch
          .stop(true, true)
          .animate({ opacity: 0 }, 0, easing2)
          .delay(100)
          .queue(function () {
            $(this).css({ display: "none" }).dequeue();
          });
        enableBodyScroll(sp);
      }
    });

    $(".p-products-search-button,.renew-p-site-header-sp-menu-button__list-search,.renew-p-site-header-sp-menu-accordion__level-3-link").on("click", function () {
      $spButton.removeClass("-active");
      $sp.removeClass("-active");
      $spOverlay
        .stop(true, true)
        .animate({ opacity: 0 }, 200, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
      $spMenu
        .stop(true, true)
        .animate({ opacity: 0 }, 0, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      enableBodyScroll(sp);
    });

    $spOverlay.on("click", function (event) {
      event.preventDefault();
      $spSearchButton.removeClass("-active");
      $spButton.removeClass("-active");
      $sp.removeClass("-active");
      $spOverlay
        .stop(true, true)
        .animate({ opacity: 0 }, 200, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      $spBg.stop(true, true).animate({ height: 0 }, 300, easing);
      $spSearch
        .stop(true, true)
        .animate({ opacity: 0 }, 0, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      $spMenu
        .stop(true, true)
        .animate({ opacity: 0 }, 0, easing2)
        .delay(100)
        .queue(function () {
          $(this).css({ display: "none" }).dequeue();
        });
      enableBodyScroll(sp);
    });
  })();

  // ==========================================================================
  // 共通: ヘッダーPC
  // ==========================================================================

  $(window).on("load", function () {
    const easing = "easeOutCubic";
    const $pcOverlay = $(".renew-p-site-header-pc-overlay");
    const $pcBg = $(".renew-p-site-header-pc-main-menu-bg");
    const $headerLink = $(".renew-p-site-header-pc-main__main");
    const $headerItem = $(".renew-p-site-header-pc-main__main-item");
    const headerItemMax = $(".renew-p-site-header-pc-main__main-item").length;
    const $headerMenu = $(".renew-p-site-header-pc-main-menu__level-1");
    const $headerPCMain = $(".renew-p-site-header-pc-main");
    const $headerMenuInner = $(".renew-p-site-header-pc-main-menu__inner");
    let lastMenuId = null;
    let timerId = [];
    let index;
    scrollbarWidth = window.innerWidth - document.body.clientWidth;
    const pcMenu = document.querySelector(".renew-p-site-header-pc-main-menu");

    $headerItem.each(function (index) {
      $(this).attr("data-link", index);
    });

    $headerItem.on("mouseenter touchstart", function (event) {
      const isPcButtonMouseEnter = event.type === "mouseenter" || "touchstart";
      const isPcButtonTouchStart = event.type === "touchstart";

      if ((index = $(this).attr("data-link"))) {
        if (isPcButtonMouseEnter) {
          if (!$headerItem.hasClass("-active")) {
            for (let i = 0; i < headerItemMax; i++) {
              clearTimeout(timerId[i]);
            }
            timerId[index] = setTimeout(function () {
              disableBodyScroll(pcMenu);
              $headerPCMain.css({ "padding-right": scrollbarWidth + "px" });
              $headerMenuInner.css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
              $("body").css("padding-right", scrollbarWidth + "px");
              $headerItem.removeClass("-active");
              $headerItem.eq(index).addClass("-active");
              $headerMenu.eq(index).stop(true, true).removeClass("-leave");
              $headerMenu.eq(index).stop(true, true).addClass("-enter");
              $pcOverlay.stop(true, true).fadeIn(300);
              const $pcMenuHeight = $headerMenu.eq(index).innerHeight();
              $pcBg.stop(true, true).animate({ height: $pcMenuHeight }, 300, easing);
            }, 100);

            lastMenuId = index;
          } else if ($headerItem.hasClass("-active")) {
            for (let i = 0; i < headerItemMax; i++) {
              clearTimeout(timerId[i]);
            }

            timerId[index] = setTimeout(function () {
              disableBodyScroll(pcMenu);
              $headerPCMain.css({ "padding-right": scrollbarWidth + "px" });
              $headerMenuInner.css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
              $("body").css("padding-right", scrollbarWidth + "px");
              $headerItem.removeClass("-active");
              $headerMenu.removeClass("-enter");
              $headerItem.eq(index).addClass("-active");
              $headerMenu.eq(index).stop(true, true).removeClass("-leave");
              $headerMenu.eq(index).stop(true, true).addClass("-enter");
              $pcOverlay.stop(true, true).fadeIn(300);
              const $pcMenuHeight = $headerMenu.eq(index).innerHeight();
              $pcBg.stop(true, true).animate({ height: $pcMenuHeight }, 300, easing);
              lastMenuId = index;
            }, 100);
          }
        }
      }

      if (isPcButtonTouchStart && lastMenuId != null) {
        if ($headerItem.hasClass("-active")) {
          if (!event.target.className.match("renew-p-site-header-pc-main__main-link")) {
            return;
          }

          for (let i = 0; i < headerItemMax; i++) {
            clearTimeout(timerId[i]);
          }

          index = $(this).attr("data-link");

          timerId[index] = setTimeout(function () {
            $headerPCMain.css({ "padding-right": "" });
            $("body").css("padding-right", "");
            enableBodyScroll(pcMenu);
            $headerItem.removeClass("-active");
            $headerMenu.removeClass("-enter");
            $headerMenu.addClass("-leave");
            $pcOverlay.stop(true, true).fadeOut(200);
            $pcBg.stop(true, true).animate({ height: 0 }, 300, easing);
          }, 300);
          lastMenuId = index;
        } else {
          for (let i = 0; i < headerItemMax; i++) {
            clearTimeout(timerId[i]);
          }

          index = $(this).attr("data-link");

          timerId[index] = setTimeout(function () {
            disableBodyScroll(pcMenu);
            $headerPCMain.css({ "padding-right": scrollbarWidth + "px" });
            $headerMenuInner.css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
            $("body").css("padding-right", scrollbarWidth + "px");
            $headerItem.removeClass("-active");
            $headerItem.eq(index).addClass("-active");
            $headerMenu.eq(index).stop(true, true).removeClass("-leave");
            $headerMenu.eq(index).stop(true, true).addClass("-enter");
            $pcOverlay.stop(true, true).fadeIn(300);
            const $pcMenuHeight = $headerMenu.eq(index).innerHeight();
            $pcBg.stop(true, true).animate({ height: $pcMenuHeight }, 300, easing);
          }, 100);
          lastMenuId = index;
        }
      }
    });

    $headerLink.on("mouseleave", function (event) {
      const isPcButtonMouseLeave = event.type === "mouseleave";

      if (isPcButtonMouseLeave) {
        for (let i = 0; i < headerItemMax; i++) {
          clearTimeout(timerId[i]);
        }

        index = $(".-active").index(".renew-p-site-header-pc-main__main-item");

        timerId[index] = setTimeout(function () {
          $headerPCMain.css({ "padding-right": "" });
          $("body").css("padding-right", "");
          enableBodyScroll(pcMenu);
          $headerItem.removeClass("-active");
          $headerMenu.removeClass("-enter");
          $headerMenu.addClass("-leave");
          $pcOverlay.stop(true, true).fadeOut(200);
          $pcBg.stop(true, true).animate({ height: 0 }, 300, easing);
        }, 100);
        lastMenuId = null;
      }
    });
  });

  // ==========================================================================
  // 共通: フッターSP
  // ==========================================================================

  (() => {
    const easing = "easeOutQuart";

    $('.renew-p-site-footer-sp-menu-accordion__level-1-accordion[href="#"]').on("click", function (event) {
      event.preventDefault();
      const $accordionLevel1 = $(this);
      const $accordionLevel2 = $accordionLevel1.siblings(".renew-p-site-footer-sp-menu-accordion__level-2");
      const $accordionLevel1Item = $accordionLevel1.parent(".renew-p-site-footer-sp-menu-accordion__level-1-item");

      if ($accordionLevel1.is(".-active")) {
        $accordionLevel1.removeClass("-active");
        $accordionLevel1Item.removeClass("-active");
        $accordionLevel2.slideUp(500, easing);
      } else {
        $accordionLevel1.addClass("-active");
        $accordionLevel1Item.addClass("-active");
        $accordionLevel2.slideDown(500, easing);
      }
    });
  })();

  // ==========================================================================
  // 共通: カテゴリ検索、条件検索　遷移処理
  // ==========================================================================

  (() => {
    let mediaQuery = new window.starterkit.MediaQuery();
    let isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
    const pathname = location.pathname;

    $(".p-products-top-category-card").on("click", function () {
      if (!isMediaUpLg) {
        const url = $(this).attr("href");
        $(this).attr("href", url + "#result");
      } else {
        const url = $(this).attr("href");
        $(this).attr("href", url);
      }
    });

    // 削除
    // $(".renew-p-site-header-sp-menu-button__list-search").on("click", function (event) {
    //   if (pathname == "/dev_tomix/products/") {
    //     $(this).attr("href", "#search");
    //   }
    // });

    $(".renew-p-site-header-sp-search__icon,.renew-p-site-header-sp-menu-accordion__level-3-link").on("click", function () {
      // if (pathname == "/dev_tomix/products/info/") {
      //   $(this).attr("href", "#result");
      // } else {
      //   const url = $(this).attr("href");
      //   $(this).attr("href", url + "#result");
      // }
      const url = $(this).attr("href");
      $(this).attr("href", url + "#result");
    });

    // 削除
    // $(".renew-p-site-header-pc-main__search-box-icon").on("click", function () {
    //   if (pathname == "/dev_tomix/products/info/") {
    //     $(this).attr("href", "#result");
    //   } else {
    //     const url = $(this).attr("href");
    //     $(this).attr("href", url);
    //   }
    // });

    // 削除
    // $(".p-products-search-button").on("click", function () {
    //   if (!isMediaUpLg) {
    //     if (pathname == "/dev_tomix/products/info/") {
    //       $(this).attr("href", "#result");
    //     } else {
    //       const url = $(this).attr("href");
    //       $(this).attr("href", url + "#result");
    //     }
    //   } else {
    //     if (pathname == "/dev_tomix/products/info/") {
    //       $(this).attr("href", "#result");
    //     } else {
    //       const url = $(this).attr("href");
    //       $(this).attr("href", url);
    //     }
    //   }
    // });

    // 削除
    // $(".renew-p-site-header-pc-main__search-box-text").on("keydown", function (event) {
    //   if (event.which === 13) {
    //     if (pathname == "/dev_tomix/products/info/") {
    //       const href = "#result";
    //       location.href = href;
    //     } else {
    //       const href = $(".renew-p-site-header-pc-main__search-box-icon").attr("href");
    //       location.href = href;
    //     }
    //   }
    // });

    // 削除
    // $(".renew-p-site-header-sp-search__box-text").on("keydown", function (event) {
    //   if (event.which === 13) {
    //     if (pathname == "/dev_tomix/products/info/") {
    //       const href = "#result";
    //       location.href = href;
    //     } else {
    //       const href = $(".renew-p-site-header-sp-search__icon").attr("href") + "#result";
    //       location.href = href;
    //     }
    //   }
    // });

    // $(".p-products-table-categories-accordion__level-1-link,.p-products-table-categories-accordion__level-2-link").on("click", function (event) {
    //   event.preventDefault();
    //   const href = "#result";
    //   location.href = href;
    // });

    const onResize = () => {
      mediaQuery = new window.starterkit.MediaQuery();
      isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
    };

    setWindowEvents({
      resize: onResize,
      scroll: null,
      load: null,
    });
  })();

  // ==========================================================================
  // 共通: フッターPC矢印
  // ==========================================================================

  (() => {
    $(".renew-p-site-footer-pc__main-menu-links-level-1-link,.renew-p-site-footer-pc__main-menu-links-level-2-link").on({
      mouseenter: function () {
        const footerLink = $(this);
        const footerArrow = footerLink.children();
        footerArrow.removeClass("-leave");
        footerArrow.addClass("-enter");
      },
      mouseleave: function () {
        const footerLink = $(this);
        const footerArrow = footerLink.children();
        footerArrow.removeClass("-enter");
        footerArrow.addClass("-leave");
      },
    });
  })();

  // ==========================================================================
  // 共通: ヘッダーPC current判定
  // ==========================================================================

  (() => {
    const directoryName = window.location.pathname.split("/")[1];

    $(".renew-p-site-header-pc-main__main-item").each(function () {
      const $menuId = $(this).data("menu-id");
      const menuIdMax = $menuId.length;

      for (let i = 0; i < menuIdMax; i++) {
        if (!location.pathname.indexOf("/" + directoryName + "/" + $menuId[i] + "/")) {
          $(this).addClass("-current");
        }
      }
    });
  })();

  // ==========================================================================
  // HOME: お知らせ 表示切り替え
  // ==========================================================================

  (() => {
    $(".p-home-news-contents-button__link").on("click", function (event) {
      event.preventDefault();
      const index = $(this).index();
      $(".p-home-news-contents-panel").eq(index).fadeIn(300);
      $(".p-home-news-contents-panel").not(`:eq(${index})`).fadeOut(0);
    });
  })();

  // ==========================================================================
  // 製品情報: タイトルの高さ
  // ==========================================================================

  (() => {
    $(".p-products-table-thumbnail-card__title").matchHeight();
  })();

  // ==========================================================================
  // 共通: ページトップへ戻る
  // ==========================================================================

  $(window).on("load", function () {
    const showTop = 100;
    const $pagetopButton = $("#js-pagetop-button");

    $pagetopButton.on("click", function (event) {
      event.preventDefault();
      $("html,body").animate({ scrollTop: 0 }, 500);
      return false;
    });

    $(window).on("load scroll resize", function () {
      if ($(window).scrollTop() >= showTop) {
        $pagetopButton.show();
      } else if ($(window).scrollTop() < showTop) {
        $pagetopButton.hide();
      }
    });

    let mediaQuery = new window.starterkit.MediaQuery();
    let isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;

    if (!isMediaUpLg) {
      $pagetopButton.parent().css("width", "");
      $pagetopButton.css("margin-right", "");
    } else {
      $pagetopButton.parent().css("width", "100vw");
      $pagetopButton.css("margin-right", scrollbarWidth + "px");
    }

    const onResize = () => {
      isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
      if (!isMediaUpLg) {
        $pagetopButton.parent().css("width", "");
        $pagetopButton.css("margin-right", "");
      } else {
        $pagetopButton.parent().css("width", "100vw");
        $pagetopButton.css("margin-right", scrollbarWidth + "px");
      }
    };

    setWindowEvents({
      resize: onResize,
      scroll: null,
      load: null,
    });
  });

  // ==========================================================================
  // 共通: ヘッダーPC タッチデバイス処理
  // ==========================================================================

  (() => {
    const $links = $(".renew-p-site-header-pc-main__main-link");
    let isTouchDevice = window.matchMedia("(any-hover: none)").matches;

    if (isTouchDevice) {
      $links.on("click", function () {
        return false;
      });
    } else {
      $links.off("click");
    }

    const onResize = () => {
      isTouchDevice = window.matchMedia("(any-hover: none)").matches;
      if (isTouchDevice) {
        $links.on("click", function () {
          return false;
        });
      } else {
        $links.off("click");
      }
    };

    setWindowEvents({
      resize: onResize,
      scroll: null,
      load: null,
    });
  })();

  // ==========================================================================
  // 製品情報: ページネーション マージン付与
  // ==========================================================================

  // (() => {
  $(function () {
    const $paginationList = $(".p-products-table-pagination-pc__list").clone(true).insertAfter(".p-products-table-pagination__inner").addClass("cloned").css({ visibility: "hidden", height: "auto", display: "inline-block" });

    $paginationList.find(".p-products-table-pagination-pc__list-text").each(function (index) {
      const $paginationMarginLeft = 124 - $(this).innerWidth();

      $paginationList
        .prev()
        .find(".p-products-table-pagination-pc__list-text")
        .eq(index)
        .css({ "margin-left": $paginationMarginLeft + "px" });
    });
    $(".cloned").remove();
  });

  // ==========================================================================
  // HOME: 今月の主な新製品情報スライダー、製品化決定スライダー スクロールバー表示非表示
  // 製品詳細: 関連製品スライダー スクロールバー表示非表示
  // ==========================================================================

  $(document).ready(function () {
    setTimeout(function () {
      if ($("#js-swiper-products-details01")[0]) {
        $(".swiper").each(function () {
          if ($(this).attr("id") == "js-swiper-products-details01") {
            const $swiper = $(this);
            let pageWidth = $swiper.outerWidth();
            const $slide = $swiper.find(".p-products-table-thumbnail-card");
            const slideMax = $slide.length;
            let slideWidth = $slide.outerWidth();
            let slidepr = parseInt($swiper.find(".p-products-table-thumbnail__item").css("padding-right"));
            let slidesWidth = slideWidth * slideMax + slidepr * (slideMax - 1);
            const $slidePrev = $swiper.find(".p-products-table-thumbnail__prev");
            const $slideNext = $swiper.find(".p-products-table-thumbnail__next");
            const $slideScrollbar = $swiper.find(".p-products-table-thumbnail__scrollbar");

            if (pageWidth > slidesWidth) {
              $slidePrev.css({ visibility: "hidden" });
              $slideNext.css({ visibility: "hidden" });
              $slideScrollbar.css({ visibility: "hidden" });
            }

            let slideWidthRight = 0;

            // if ($swiper.attr("id") == "js-swiper-products-details" && slideMax > 4) {
            //   slideWidthRight = $(document).width() - $swiper.offset().left;

            //   if (slideWidthRight > slidesWidth) {
            //     $slidePrev.css({ visibility: "hidden" });
            //     $slideNext.css({ visibility: "hidden" });
            //     $slideScrollbar.css({ visibility: "hidden" });
            //     $swiper.children(".swiper-wrapper").addClass("-lock");
            //   }
            // }

            if ($swiper.attr("id") == "js-swiper-products-details01" && slideMax > 4) {
              slideWidthRight = $(document).width() - $swiper.offset().left;

              if (slideWidthRight > slidesWidth) {
                $slidePrev.css({ visibility: "hidden" });
                $slideNext.css({ visibility: "hidden" });
                $slideScrollbar.css({ visibility: "hidden" });
                $swiper.children(".swiper-wrapper").addClass("-lock");
              }
            }

            // if (($swiper.attr("id") == "js-swiper-new-product-information" || $swiper.attr("id") == "js-swiper-productization-decision") && slideMax > 3) {
            //   slideWidthRight = $(document).width() - $swiper.offset().left;

            //   if (slideWidthRight > slidesWidth) {
            //     $slidePrev.css({ visibility: "hidden" });
            //     $slideNext.css({ visibility: "hidden" });
            //     $slideScrollbar.css({ visibility: "hidden" });
            //   }
            // }

            let lastWidth = window.innerWidth;
            let timeoutID = 0;
            const delay = 200;

            const onResize = () => {
              clearTimeout(timeoutID);
              if (lastWidth != window.innerWidth) {
                timeoutID = setTimeout(function () {
                  pageWidth = $swiper.outerWidth();
                  slideWidth = $slide.outerWidth();
                  slidepr = parseInt($(".p-products-table-thumbnail__item").css("padding-right"));
                  slidesWidth = slideWidth * slideMax + slidepr * (slideMax - 1);

                  if (pageWidth > slidesWidth) {
                    $slidePrev.css({ visibility: "hidden" });
                    $slideNext.css({ visibility: "hidden" });
                    $slideScrollbar.css({ visibility: "hidden" });
                  } else {
                    $slidePrev.css({ visibility: "" });
                    $slideNext.css({ visibility: "" });
                    $slideScrollbar.css({ visibility: "" });
                    $slideScrollbar.children().css({ transform: "translate3d(0, 0px, 0px)" });
                    $swiper.children(".swiper-wrapper").css({ transform: "translate3d(0, 0px, 0px)" });
                    $swiper.children(".swiper-wrapper").removeClass("-lock");
                  }

                  // if ($swiper.attr("id") == "js-swiper-products-details" && slideMax > 4) {
                  //   slideWidthRight = $(document).width() - $swiper.offset().left;

                  //   if (slideWidthRight > slidesWidth) {
                  //     $slidePrev.css({ visibility: "hidden" });
                  //     $slideNext.css({ visibility: "hidden" });
                  //     $slideScrollbar.css({ visibility: "hidden" });
                  //     $swiper.children(".swiper-wrapper").addClass("-lock");
                  //   }
                  // }

                  if ($swiper.attr("id") == "js-swiper-products-details01" && slideMax > 4) {
                    slideWidthRight = $(document).width() - $swiper.offset().left;

                    if (slideWidthRight > slidesWidth) {
                      $slidePrev.css({ visibility: "hidden" });
                      $slideNext.css({ visibility: "hidden" });
                      $slideScrollbar.css({ visibility: "hidden" });
                      $swiper.children(".swiper-wrapper").addClass("-lock");
                    }
                  }

                  // if (($swiper.attr("id") == "js-swiper-new-product-information" || $swiper.attr("id") == "js-swiper-productization-decision") && slideMax > 3) {
                  //   slideWidthRight = $(document).width() - $swiper.offset().left;

                  //   if (slideWidthRight > slidesWidth) {
                  //     $slidePrev.css({ visibility: "hidden" });
                  //     $slideNext.css({ visibility: "hidden" });
                  //     $slideScrollbar.css({ visibility: "hidden" });
                  //     $swiper.children(".swiper-wrapper").addClass("-lock");
                  //   }
                  // }
                }, delay);
                lastWidth = window.innerWidth;
              }
            };

            setWindowEvents({
              resize: onResize,
              scroll: null,
              load: null,
            });
          }
        });
      }
    }, 300);
  });

  // ==========================================================================
  // HOME: 今月の主な新製品情報スライダー、製品化決定スライダー、掲載物アーカイブスライダー 画像の遅延読み込み
  // 製品詳細: 関連製品スライダー 画像の遅延読み込み
  // ==========================================================================
  (() => {
    lazyload();
  })();

  // ==========================================================================
  // ブラウザバック時リロード
  // ==========================================================================
  $(document).ready(function () {
    if (window.performance.navigation.type == 2) {
      // console.log("ブラウザバック");
      window.location.reload();
    }
  });
})();

// ==========================================================================
// データ送信
// ==========================================================================

// 検索窓
function productsValueContainerFunction(event) {
  event.preventDefault();

  // FORM
  let searchForm = event.target.closest(".js-search-form");

  // データ
  let q = searchForm.elements.q.value;
  let year = searchForm.elements.year.value;
  let month = searchForm.elements.month.value;
  let category = searchForm.elements.category.value;

  // 変換
  let q_hankaku = convertToHalfWidth(q);
  let q_katakana = kanaHalfToFull(q_hankaku);

  // console.log("検索ワード", q_katakana);
  // console.log("年", year);
  // console.log("月", month);
  // console.log("カテゴリ", category);

  // パラメータ
  const params = new URLSearchParams();

  // パラメータセット
  params.set("q", q_katakana);
  params.set("year", year);
  params.set("month", month);
  if (category === "N" || category === "HO") {
    params.set("nho", category);
  } else {
    params.set("category", category);
  }
  params.set("flag", "search");

  // #result
  let mediaQuery = new window.starterkit.MediaQuery();
  let isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
  let resultTxt = "";

  if (!isMediaUpLg) {
    resultTxt = "#result";
  }

  window.location.href = searchForm.action + "?" + params.toString() + resultTxt;
}

// ENTERキー
function handleKeyPress(event) {
  if (event.keyCode === 13) {
    productsValueInputFunction(event);
  }
}

// 検索ワードのみ
function productsValueInputFunction(event) {
  event.preventDefault();

  // FORM
  let searchForm = event.target.closest(".js-search-form");

  // データ
  let q = searchForm.elements.q.value;

  // 変換
  let q_hankaku = convertToHalfWidth(q);
  let q_katakana = kanaHalfToFull(q_hankaku);

  // console.log("検索ワード", q_katakana);

  // パラメータ
  const params = new URLSearchParams();

  // パラメータセット
  params.set("q", q_katakana);
  params.set("flag", "search");

  // #result
  let mediaQuery = new window.starterkit.MediaQuery();
  let isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
  let resultTxt = "";

  if (!isMediaUpLg) {
    resultTxt = "#result";
  }

  window.location.href = searchForm.action + "?" + params.toString() + resultTxt;
}

// ==========================================================================
// 製品詳細の戻るボタン
// ==========================================================================
function returnDetailsFunction(event) {
  event.preventDefault();

  // URL履歴
  const ref = document.referrer;
  let reNewUrl = false;
  let refParameter = false;
  let refPathname = false;
  if (ref) {
    reNewUrl = new URL(document.referrer);
    refParameter = reNewUrl.searchParams.size;
    refPathname = reNewUrl.pathname;
    if (refParameter !== 0 && refPathname.includes("products/info")) {
      // 検索維持
      window.location.href = ref;
    } else {
      window.location.href = event.target.getAttribute("href");
    }
  } else {
    window.location.href = event.target.getAttribute("href");
  }
}

function scheduleSmoothScrolling(event) {
  event.preventDefault();

  // console.log();

  let mediaQuery = new window.starterkit.MediaQuery();
  let isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
  let headerHeight = 0;
  if (!isMediaUpLg) {
    headerHeight = 61;
  } else {
    headerHeight = 114;
  }

  const $target = $(event.target.getAttribute("href"));
  const $position = $($target).offset().top - headerHeight;
  $("html,body").animate({ scrollTop: $position }, 500);
}

// ==========================================================================
// 全角英数字を半角英数字に変換
// ==========================================================================
function convertToHalfWidth(str) {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
}

// ==========================================================================
// 半角カタカナを全角カタカナに変換
// ==========================================================================
function convertToFullWidthKatakana(str) {
  return str.replace(/[ｦ-ﾟ]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
  });
}

function kanaHalfToFull(str) {
  var kanaMap = {
    ｶﾞ: "ガ",
    ｷﾞ: "ギ",
    ｸﾞ: "グ",
    ｹﾞ: "ゲ",
    ｺﾞ: "ゴ",
    ｻﾞ: "ザ",
    ｼﾞ: "ジ",
    ｽﾞ: "ズ",
    ｾﾞ: "ゼ",
    ｿﾞ: "ゾ",
    ﾀﾞ: "ダ",
    ﾁﾞ: "ヂ",
    ﾂﾞ: "ヅ",
    ﾃﾞ: "デ",
    ﾄﾞ: "ド",
    ﾊﾞ: "バ",
    ﾋﾞ: "ビ",
    ﾌﾞ: "ブ",
    ﾍﾞ: "ベ",
    ﾎﾞ: "ボ",
    ﾊﾟ: "パ",
    ﾋﾟ: "ピ",
    ﾌﾟ: "プ",
    ﾍﾟ: "ペ",
    ﾎﾟ: "ポ",
    ｳﾞ: "ヴ",
    ﾜﾞ: "ヷ",
    ｦﾞ: "ヺ",
    ｱ: "ア",
    ｲ: "イ",
    ｳ: "ウ",
    ｴ: "エ",
    ｵ: "オ",
    ｶ: "カ",
    ｷ: "キ",
    ｸ: "ク",
    ｹ: "ケ",
    ｺ: "コ",
    ｻ: "サ",
    ｼ: "シ",
    ｽ: "ス",
    ｾ: "セ",
    ｿ: "ソ",
    ﾀ: "タ",
    ﾁ: "チ",
    ﾂ: "ツ",
    ﾃ: "テ",
    ﾄ: "ト",
    ﾅ: "ナ",
    ﾆ: "ニ",
    ﾇ: "ヌ",
    ﾈ: "ネ",
    ﾉ: "ノ",
    ﾊ: "ハ",
    ﾋ: "ヒ",
    ﾌ: "フ",
    ﾍ: "ヘ",
    ﾎ: "ホ",
    ﾏ: "マ",
    ﾐ: "ミ",
    ﾑ: "ム",
    ﾒ: "メ",
    ﾓ: "モ",
    ﾔ: "ヤ",
    ﾕ: "ユ",
    ﾖ: "ヨ",
    ﾗ: "ラ",
    ﾘ: "リ",
    ﾙ: "ル",
    ﾚ: "レ",
    ﾛ: "ロ",
    ﾜ: "ワ",
    ｦ: "ヲ",
    ﾝ: "ン",
    ｧ: "ァ",
    ｨ: "ィ",
    ｩ: "ゥ",
    ｪ: "ェ",
    ｫ: "ォ",
    ｯ: "ッ",
    ｬ: "ャ",
    ｭ: "ュ",
    ｮ: "ョ",
    "｡": "。",
    "､": "、",
    ｰ: "ー",
    "｢": "「",
    "｣": "」",
    "･": "・",
  };

  var reg = new RegExp("(" + Object.keys(kanaMap).join("|") + ")", "g");
  return str
    .replace(reg, function (match) {
      return kanaMap[match];
    })
    .replace(/ﾞ/g, "゛")
    .replace(/ﾟ/g, "゜");
}

// ==========================================================================
// Setting json-LD
// ==========================================================================

// 削除
// $(function () {
//   setJosnBread($(".js-breadcrumb"));
// });

// function setJosnBread($obj_bread) {
//   if ($obj_bread.attr("id") === "breadcrumb") {
//     let $dataBread = [];
//     $obj_bread.find("ul li").each(function (i, o) {
//       let $dataBreadItem = {};
//       $dataBreadItem["@type"] = "ListItem";
//       $dataBreadItem["position"] = i + 1;

//       if ($dataBreadItem["position"] === 1) {
//         $dataBreadItem["name"] = $.trim($(o).find("a").text());
//         $dataBreadItem["item"] = "https://www.tomytec.co.jp/tomix/";
//       } else {
//         if ($(o).find("a").length > 0) {
//           $dataBreadItem["name"] = $.trim($(o).find("a").text());
//           $dataBreadItem["item"] = $.trim($(o).find("a").attr("href"));
//         } else {
//           $dataBreadItem["name"] = $.trim($(o).text());
//           $dataBreadItem["item"] = "";
//         }
//       }

//       $dataBread.push($dataBreadItem);
//     });

//     if ($dataBread.length) {
//       data = {
//         "@context": "https://schema.org",
//         "@type": "BreadcrumbList",
//         itemListElement: $dataBread,
//       };
//       const script = document.createElement("script");
//       script.type = "application/ld+json";
//       script.innerHTML = JSON.stringify(data);
//       document.getElementsByTagName("head")[0].appendChild(script);
//     }
//   } else {
//     if ($obj_bread.length) {
//       let $dataBread = [];
//       $obj_bread.find("ol li").each(function (i, o) {
//         let $dataBreadItem = {};
//         $dataBreadItem["@type"] = "ListItem";
//         $dataBreadItem["position"] = i + 1;

//         if ($dataBreadItem["position"] === 1) {
//           $dataBreadItem["name"] = $.trim($(o).find("a").text());
//           $dataBreadItem["item"] = "https://www.tomytec.co.jp/tomix/";
//         } else {
//           if ($(o).find("a").length > 0) {
//             $dataBreadItem["name"] = $.trim($(o).find("a").text());
//             $dataBreadItem["item"] = $.trim($(o).find("a").attr("href"));
//           } else {
//             $dataBreadItem["name"] = $.trim($(o).find("span").text());
//             $dataBreadItem["item"] = "";
//           }
//         }

//         $dataBread.push($dataBreadItem);
//       });

//       if ($dataBread.length) {
//         data = {
//           "@context": "https://schema.org",
//           "@type": "BreadcrumbList",
//           itemListElement: $dataBread,
//         };
//         const script = document.createElement("script");
//         script.type = "application/ld+json";
//         script.innerHTML = JSON.stringify(data);
//         document.getElementsByTagName("head")[0].appendChild(script);
//       }
//     }
//   }
// }

// ==========================================================================
// TOMIX入門: 動画モーダル
// ==========================================================================

$(function () {
  if ($(".js-modal-movie-id")[0]) {
    const speed = 0;
    const modalMovieOpenBtns = document.querySelectorAll(".js-modal-movie-open");
    const modalMovieCloseBtns = document.querySelectorAll(".js-modal-movie-close");
    const $html = $(document.documentElement);
    let scrollTop;
    const device = document.documentElement.getAttribute("class");

    modalMovieOpenBtns.forEach((modalMovieOpenBtn) => {
      modalMovieOpenBtn.addEventListener("click", function () {
        const id = $(this).next().find(".js-modal-movie-id").attr("data-id");
        const $modalMovie = $(this).next();
        const $modalMovieOverlay = $(this).closest(".p-introduction-movie__wrapper").find(".js-modal-movie__overlay");
        scrollbarWidth = window.innerWidth - document.body.clientWidth;

        if (device.includes("mobile") || device.includes("tablet")) {
          scrollTop = $(window).scrollTop();
          $html.css({ "padding-right": scrollbarWidth + "px", position: "fixed", top: -scrollTop, left: 0, right: 0, overflow: "hidden" });
        } else {
          $("body").css({ "padding-right": scrollbarWidth });
          document.documentElement.style.cssText = "overflow: hidden;";
        }

        $(".js-modal-movie").css({ width: "calc(100vw - " + scrollbarWidth + "px)" });
        $(".renew-p-site-header-pc-main").css({ "padding-right": scrollbarWidth + "px" });
        const target = this.nextElementSibling;
        bodyScrollLock.disableBodyScroll(target);
        $modalMovie.addClass("is-active");
        $modalMovieOverlay.addClass("is-active");
        $(this)
          .next()
          .find(".js-modal-movie-id")
          .append('<iframe src="https://www.youtube.com/embed/' + id + "?rel=0&start=" + speed + '&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
      });
    });

    modalMovieCloseBtns.forEach((modalMovieCloseBtn) => {
      modalMovieCloseBtn.addEventListener("click", function () {
        if (device.includes("mobile") || device.includes("tablet")) {
          $html.css({ "padding-right": "", position: "", top: "", left: "", right: "", overflow: "" });
          $(window).scrollTop(scrollTop, 0);
        } else {
          $("body").css({ "padding-right": "" });
          document.documentElement.style.cssText = "";
        }

        let target;
        if (this.classList.contains("js-modal-movie__overlay")) {
          target = this.closest(".p-introduction-movie__wrapper").querySelector(".js-modal-movie");
        } else {
          target = this.closest(".p-introduction-movie-modal");
        }

        bodyScrollLock.enableBodyScroll(target);
        $(".renew-p-site-header-pc-main").css({ "padding-right": "" });

        $(".js-modal-movie")
          .animate({ opacity: 0 }, 200, "easeInOutQuad")
          .queue(function () {
            $(".js-modal-movie-id").empty();
            $(this).removeClass("is-active");
            $(this).css({ opacity: "", width: "" }).dequeue();
          });

        $(".js-modal-movie__overlay")
          .animate({ opacity: 0 }, 200, "easeInOutQuad")
          .queue(function () {
            $(".js-modal-movie-id").empty();
            $(this).removeClass("is-active");
            $(this).css({ opacity: "" }).dequeue();
          });
      });
    });
  }
});

// ==========================================================================
// TOMIX入門: ページ内リンクスクロール
// ==========================================================================

$(function () {
  $(".js-introduction-nav-list-link").click(function () {
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    const mediaQuery = new window.starterkit.MediaQuery();
    const isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;

    if (isMediaUpLG) {
      position = position - 114;
    } else {
      position = position - 61;
    }

    $("html, body").animate({ scrollTop: position }, speed, "swing");
  });
});
